import HomeHeader from './HomeHeader'
import { Layout } from 'antd'
import React from 'react'

import './HomeLayout.less'

const HomeLayout = ({ allowSignIn, children, showHero }) => {
  return (
    <Layout>
      <HomeHeader allowSignIn={allowSignIn} />
      <Layout.Content>{children}</Layout.Content>
    </Layout>
  )
}

HomeLayout.propTypes = {}

export default HomeLayout
